import { Stack } from 'expo-router';
import { useMemo } from 'react';

import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';
import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';

import { getScreenTitleHeader } from '../../components/get-screen-title-header';

export default function RedeemLayout() {
  const { isAuthenticated } = useAuthContext();
  const isRewardsTiersEnabled = useFlag(LaunchDarklyFlag.ENABLE_REWARDS_TIERS);

  const options = useMemo(
    () =>
      isRewardsTiersEnabled
        ? ({
            presentation: 'containedTransparentModal',
            headerShown: false,
            contentStyle: { backgroundColor: 'transparent' },
            animation: 'none',
          } as const)
        : ({
            header: getScreenTitleHeader({ backStyle: isAuthenticated ? 'back' : 'close' }),
            presentation: isAuthenticated ? undefined : 'fullScreenModal',
            animation: isAuthenticated ? 'none' : 'slide_from_left',
          } as const),
    [isRewardsTiersEnabled, isAuthenticated]
  );
  return (
    <Stack>
      <Stack.Screen name="index" options={options} />
    </Stack>
  );
}
